const LoggerMethods = ["warn", "error", "log"];
class Logger {
  static error(options) {
    this._generic({ ...options, method: "error" });
  }
  static log(options) {
    this._generic({ ...options, method: "log" });
  }
  static warn(options) {
    this._generic({ ...options, method: "warn" });
  }
  static _generic(options) {
    if (options.title) {
      console[options.method](`%c${options.title} 
 `, "font-weight: bold", options.message);
    } else {
      console[options.method](options.message);
    }
  }
}

export { Logger, LoggerMethods };
